import { useNavigate } from "react-router-dom";
import useTranslator from "../../../hooks/useTranslator";

const GuarantorDocsStep = (props) => {
  const { guarantorData } = props;
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const navigateGuarantorDocs = () => {
    navigate("/guarantor/docs");
  };

  return (
    <>
      <div className="tenant-doc-tile">
        <div className="border-pd">
          <ul>
            <li className="d-flex tile-design border-0 p-0 m-0 cursor-pointer">
              <div className="tile-content-wrapper">
                <img src="/images/document-home-icon.svg" alt="" />
                <div className="tile-content">
                  <h4 className="tile-heading">
                    {_t(
                      "provideGuarantorDocuments",
                      "Heading on tenant side while adding guarantor"
                    )}
                  </h4>

                  <p className="tile-desc-completed">
                    {_t(
                      "provideGuarantorDocumentsDesc",
                      "Description on tenant side while adding guarantor"
                    )}
                  </p>
                </div>
                <div className="d-flex align-items-center gap-4 tile-btns-wrapper ms-auto">
                  {guarantorData?.docs_uploaded ? (
                    <button className="grey-completed-btn">
                      {_t("completed")}
                    </button>
                  ) : (
                    <button
                      className="btn btngreen "
                      onClick={navigateGuarantorDocs}
                    >
                      {_t("complete")}
                    </button>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
export default GuarantorDocsStep;
